import React from "react";
import { DataTable } from "./DataTable";
import { Button, Upload } from "antd";
import { YhBox } from "@/components/YhBox";
import { useCustomerDiscountModel } from "../customerDiscountModel";
import useNavModel from "@/model/navModel";
import useGlobalModel from "@/model/globalModel";
import { YhAuth } from "@/components/auth/YhAuth";
import { globalPrompt } from "@/components/YhMessage";
import { ResourceAuthEnum } from "@/types/FmsResourceAuthEnum";

export const DataBox = () => {
    const { selectedRowKeys, updateEditFormVal, exportCustomerDiscount, exportLoading } = useCustomerDiscountModel();
    const { addNav, findNav, selectNav, switchNavState } = useNavModel(() => []);

    const onEdit = () => {
        if (selectedRowKeys.length !== 1) {
            globalPrompt("message", { text: "请选择单条数据进行编辑，点击鼠标右键可一键选中哦！", type: "warning" });
            return;
        }
        let editKey = "2-5-2";
        let isFindNav = findNav(editKey);
        if (!isFindNav) {
            addNav(editKey, { id: selectedRowKeys[0]?.id, mode: "edit" });
            updateEditFormVal(null);
        } else {
            switchNavState(editKey, { id: selectedRowKeys[0]?.id, mode: "edit" });
            updateEditFormVal(null);
        }
    }

    const action = <>
        <YhAuth resCode={ResourceAuthEnum.ACC_C_YH_AD}>
            <Button
                className="mr-5"
                type="link"
                shape="round"
                onClick={() => addNav("2-5-1", { id: "", mode: "add" })}
            >新增</Button>
        </YhAuth>
        <YhAuth resCode={ResourceAuthEnum.ACC_C_YH_ED}>
            <Button
                className="mr-5"
                type="link"
                shape="round"
                onClick={onEdit}
            >编辑</Button>
        </YhAuth>
        <YhAuth resCode={ResourceAuthEnum.ACC_C_YH_EX}>
            <Button
                className="mr-5"
                type="link"
                shape="round"
                loading={exportLoading}
                onClick={() => exportCustomerDiscount()}
            >导出</Button>
        </YhAuth>
    </>;

    return (
        <YhBox title="" action={action}>
            <DataTable />
        </YhBox>
    )
}